/**
 * @generated SignedSource<<f3da6975c4a5e35fe0ad5dd5f0ad8889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SingatureType = "CONTRACT" | "EOA" | "%future added value";
export type CreateNewDelegateStatementData = {
  email?: ValueWithSignature | null;
  statement: ValueWithSignature;
};
export type ValueWithSignature = {
  signature: string;
  signatureType: SingatureType;
  signerAddress: string;
  value: string;
};
export type DelegateStatementFormMutation$variables = {
  input: CreateNewDelegateStatementData;
};
export type DelegateStatementFormMutation$data = {
  readonly createNewDelegateStatement: {
    readonly statement: {
      readonly discord: string;
      readonly leastValuableProposals: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly mostValuableProposals: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly openToSponsoringProposals: boolean | null;
      readonly statement: string;
      readonly topIssues: ReadonlyArray<{
        readonly type: string;
        readonly value: string;
      }>;
      readonly twitter: string;
    } | null;
  };
};
export type DelegateStatementFormMutation = {
  response: DelegateStatementFormMutation$data;
  variables: DelegateStatementFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "data",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statement",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discord",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitter",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "TopIssue",
  "kind": "LinkedField",
  "name": "topIssues",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openToSponsoringProposals",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegateStatementFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "createNewDelegateStatement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "mostValuableProposals",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "leastValuableProposals",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegateStatementFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "createNewDelegateStatement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "mostValuableProposals",
                "plural": true,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "leastValuableProposals",
                "plural": true,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ceaee557ab837d36105d1514139b592",
    "id": null,
    "metadata": {},
    "name": "DelegateStatementFormMutation",
    "operationKind": "mutation",
    "text": "mutation DelegateStatementFormMutation(\n  $input: CreateNewDelegateStatementData!\n) {\n  createNewDelegateStatement(data: $input) {\n    statement {\n      statement\n      mostValuableProposals {\n        __typename\n        id\n      }\n      leastValuableProposals {\n        __typename\n        id\n      }\n      discord\n      twitter\n      topIssues {\n        type\n        value\n      }\n      openToSponsoringProposals\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac0f3c76d0b941729761e1ba300ebfd8";

export default node;
